import React, { useState } from "react";

const DropdownPickerText = ({
  options,
  onSelect,
  selectedValue,
  placeholder,
  style,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [searchText, setSearchText] = useState("");

  const filteredOptions = options.filter((item) =>
    item.label.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div style={{ position: "relative", margin: "5px 0" }}>
      {/* Dropdown Button */}
      <div
        onClick={() => {
          setIsVisible(!isVisible);
          setSearchText("");
        }}
        style={{
          border: "1px solid #ccc",
          borderRadius: 6,
          padding: style?.padding || 6,
          background: style?.backgroundColor || "#fff",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minWidth: 180,
        }}
      >
        <span
          style={{
            fontSize: style?.fontSize || 13,
            color: style?.color || "#333",
          }}
        >
          {options.find((item) => item.value === selectedValue)?.label ||
            placeholder}
        </span>
        <span style={{ fontSize: 18 }}>▼</span>
      </div>

      {/* Dropdown List */}
      {isVisible && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            left: 0,
            width: "100%",
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: 6,
            maxHeight: 200,
            overflowY: "auto",
            zIndex: 1000,
            padding: 8,
          }}
        >
          {/* Search bar */}
          <input
            type="text"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{
              width: "100%",
              padding: 6,
              marginBottom: 6,
              borderRadius: 4,
              border: "1px solid #ddd",
            }}
            autoFocus
          />

          {/* Options */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((item, i) => (
              <div
                key={i}
                onClick={() => {
                  onSelect(item.value);
                  setIsVisible(false);
                }}
                style={{
                  padding: 8,
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                }}
              >
                {item.label}
              </div>
            ))
          ) : (
            <div
              style={{
                padding: 8,
                textAlign: "center",
                color: "#999",
                fontStyle: "italic",
              }}
            >
              No matching options
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DropdownPickerText;
